import React, { Component } from 'react';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';
import { IconButton } from '@studio/legacy-components';
import { pressedEnter } from 'utils/forms';

const ConfirmButton = styled(IconButton)`
  color: #05db99;
`;

class CreateTagOption extends Component {
  state = {
    newTagName: '',
  };

  componentDidMount() {
    if (this.input) {
      this.input.focus();
    }
  }

  handleChange() {
    return event => {
      this.setState({
        newTagName: event.target.value,
      });
    };
  }

  handleKeyPressInput() {
    return event => {
      if (pressedEnter(event)) {
        this.doCreateTag();
      }
    };
  }

  doCreateTag = () => {
    const { handleCreateTag } = this.props;

    if (!handleCreateTag) {
      return;
    }

    const { newTagName } = this.state;
    handleCreateTag(newTagName);
  };

  cancelCreatingTag() {
    return () => {
      const { handleCancelCreatingTag } = this.props;
      if (handleCancelCreatingTag) {
        handleCancelCreatingTag();
      }
    };
  }

  createTag() {
    return () => {
      this.doCreateTag();
    };
  }

  render() {
    const { className } = this.props;
    const { newTagName } = this.state;
    return (
      <div className={className}>
        <div className="tagName">
          <input
            ref={i => {
              this.input = i;
            }}
            placeholder="Enter a new tag name"
            value={newTagName}
            onChange={this.handleChange()}
            onKeyPress={this.handleKeyPressInput()}
          />
        </div>

        <ConfirmButton
          label="Create tag"
          icon="check-circle"
          onClick={this.createTag()}
        />

        <IconButton
          label="Cancel"
          icon={['far', 'times-circle']}
          onClick={this.cancelCreatingTag()}
        />
      </div>
    );
  }
}

CreateTagOption.propTypes = {
  handleCreateTag: PropTypes.func.isRequired,
  handleCancelCreatingTag: PropTypes.func.isRequired,
};

export default styled(CreateTagOption)`
  display: flex;
  align-items: center;

  .tagName {
    border-radius: 20px;
    padding: 5px 8px;
    margin-right: 9px;
    background-color: #bac0ca;
    color: #ffffff;
    cursor: pointer;
    max-width: 75%;

    input {
      background: transparent;
      border: none;
      outline: none;
      color: #ffffff;
    }

    input::placeholder {
      color: #ffffff;
      font-style: italic;
    }
  }
`;
